import React from 'react';
import { MemberInsights } from '@frontend/gql/social/graphql';
import { HandWaveIcon, EyeIcon } from '@revfluence/fresh-icons/regular/esm';
import {
  PostCard,
  PostCardMedia,
  PostCardBackground,
  PostCardContent,
  PostCardImageContainer,
  PostCardImageContent,
  PostCardImage,
  PostCardPlaceholder,
  PostCardGradient,
  PostCardHeader,
  PostCardAvatar,
  PostCardAvatarImage,
  PostCardAvatarFallback,
  PostCardAvatarName,
  PostCardFooter,
  PostCardActions,
  PostCardStats,
  PostCardStat,
  PostCardAvatarContainer,
  PostCardHeaderRow,
} from '@frontend/applications/Social/components/post-card';

interface TopCreatorsCardProps {
  creator: MemberInsights;
  isSelected?: boolean;
}

const TopCreatorsCard: React.FC<TopCreatorsCardProps> = ({
  creator,
  isSelected = false,
}) => {
  if (!creator) return null;
  const member = creator.member;
  const total = creator.total;
  const memberName = member?.name || '';
  const profilePicture = member?.profilePicture || '';

  return (
    <PostCard className={isSelected ? 'ring-2 ring-primary-500' : ''}>
      <PostCardMedia>
        {profilePicture ? (
          <>
            <PostCardBackground imageUrl={profilePicture} />
            <PostCardImageContainer>
              <PostCardImageContent>
                <PostCardImage src={profilePicture} alt={memberName} />
              </PostCardImageContent>
            </PostCardImageContainer>
          </>
        ) : (
          <PostCardPlaceholder />
        )}
        <PostCardGradient />
      </PostCardMedia>

      <PostCardContent>
        <PostCardHeader>
          <PostCardHeaderRow>
            <PostCardAvatarContainer>
              <PostCardAvatar>
                <PostCardAvatarImage src={profilePicture} alt={memberName} />
                <PostCardAvatarFallback name={memberName} />
              </PostCardAvatar>
              <PostCardAvatarName>{memberName}</PostCardAvatarName>
            </PostCardAvatarContainer>
          </PostCardHeaderRow>
        </PostCardHeader>

        <div className="flex-grow" />

        <PostCardFooter>
          <PostCardActions>
            <PostCardStats>
              {total?.engagements != null && (
                <PostCardStat
                  icon={<HandWaveIcon className="h-4 w-4" />}
                  value={total.engagements}
                />
              )}
              {total?.impressions != null && (
                <PostCardStat
                  icon={<EyeIcon className="h-4 w-4" />}
                  value={total.impressions}
                />
              )}
            </PostCardStats>
          </PostCardActions>
        </PostCardFooter>
      </PostCardContent>
    </PostCard>
  );
};

export default TopCreatorsCard;
